import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Outlet } from 'react-router'

const MinimalLayout = () => {
  return <Outlet />
}

MinimalLayout.propTypes = {
  children: PropTypes.node,
}

const mapStateToProps = (state) => ({
  headerDrawerToggle:
    state.DeprecatedThemeOptions?.headerDrawerToggle,
})

export default connect(mapStateToProps)(MinimalLayout)
